import { FACET_LIMITS } from '../constants/facetsInfo.constant';

export const showElement = (facets, field, type) => {
  if (!facets || !field || !type) return false;

  const facetValues = facets[field]?.[0]?.data || [];
  const limit = FACET_LIMITS[type];

  if (limit === undefined) {
    console.error(`Invalid facet type: ${type}`);
    return false;
  }

  
  return facetValues.length > limit;
};